import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets body styles on every route change to prevent iOS WebView
 * glitches caused by leftover modal/popup styles.
 */
const RouteChangeReset = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.remove("scroll-lock");
    document.body.style.overflow = "";
    document.body.style.top = "";

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default RouteChangeReset;
